<template>
  <span class="svg-icon-commo-chat">
    <svg class="icon-color-1" :style="`width:${width}px; height:${width}px; fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 6H21C21.5523 6 22 5.55228 22 5C22 4.44772 21.5523 4 21 4H3C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6ZM3 13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13ZM21 20H3C2.44772 20 2 19.5523 2 19C2 18.4477 2.44772 18 3 18H21C21.5523 18 22 18.4477 22 19C22 19.5523 21.5523 20 21 20Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default: '#000000' },
    color2: { type: String, default: '#FFE5E7' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
